import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "free-events-landing-page" */ './FreeEventsLandingPageCtnr'));
export const FreeEventLandingPage = Loadable(
  () => import(/* webpackChunkName: "free-events-landing-page" */ './FreeEventLandingPageCtnr'),
);
